import styled from "styled-components/macro";

export const StyledContentBlock = styled.div`
  a {
    color: #008067;
    text-overflow: ellipsis;
  }
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Heading = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  color: #007961;
  padding: 0;
  margin: 0;
  padding-bottom: 15px;
`;
